module.exports = __webpack_public_path__ + "img/compliance.a550c685.jpg";